import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const AssignTaskFilled = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.51 3h7.3c2.48 0 4.51 2.03 4.51 4.51v4.08l-.03.03-4.58 4.88-.32-.35a2.497 2.497 0 1 0-3.66 3.4L12.07 21H7.51C5.03 21 3 18.97 3 16.49V7.51C3 5.03 5.03 3 7.51 3Zm-.19 9.29h4.25c.44 0 .8-.36.8-.8 0-.44-.36-.8-.8-.8H7.32c-.44 0-.8.36-.8.8 0 .44.36.8.8.8Zm0-3.49H14.68c.44 0 .8-.36.8-.8 0-.44-.36-.8-.8-.8H7.32c-.44 0-.8.36-.8.8 0 .44.36.8.8.8Zm13.44 6.163a.9.9 0 1 0-1.32-1.226l-4.739 5.1-1.48-1.599a.9.9 0 1 0-1.321 1.224l2.14 2.31a.9.9 0 0 0 1.32 0l5.4-5.81Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default AssignTaskFilled
